import { Navigate, Outlet } from "react-router-dom";
import { getUserType } from "../../utils/appUtils";

const getRedirectPath = (role) => {
    switch (role) {
      case "organizer":
        return "/dashboard";
      case "user":
        return "/discover-events";
      case "guest":
        return "/login";
      default:
        return "/";
    }
  };

/**
 * ProtectedRoute — Guards pages based on allowed roles.
 * If the current role is not in allowedRoles, redirects using getRedirectPath
 * (e.g. guest to /login, user to /discover-events, organizer to /dashboard).
 */
const ProtectedRoute = ({ allowedRoles }) => {
 const activeRole = getUserType();

  // Role not allowed
  if (allowedRoles && !allowedRoles.includes(activeRole)) {
    return <Navigate to={getRedirectPath(activeRole)} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;